import React from "react";
import logo from '../assets/logo.png';

const TicketNoBuy = (props) => {
  // console.log("props",props)
  let splitData = props?.data?.lotteryNumber.split('')
  // console.log("splitData",splitData)
  const NumberItem = (props) => {
    return (
      <p className="text-[#b3853e] bg-white rounded text-base w-full h-6 md:text-2xl md:h-8">
       {props.num}
      </p>
    );
  };

  return (
    <div className="rounded-md bg-white border border-[#b3853e] shadow shadow-[#b3853e]">
      <div className=" bg-[#b3853e] text-[#b3853e] rounded p-1 shadow">
        {/* <p className="text-end font-normal text-xs "> ใบที่ {props?.data?.refcode}</p> */}
        <div className="grid grid-cols-6 gap-1 place-items-center pb-1.5 rounded-md">
          <NumberItem num={splitData[0]}/>
          <NumberItem num={splitData[1]}/>
          <NumberItem num={splitData[2]}/>
          <NumberItem num={splitData[3]}/>
          <NumberItem num={splitData[4]}/>
          <NumberItem num={splitData[5]}/>
        </div>
        <div className="mx-10">
          <img src={logo} alt="logoticket" />
        </div>
      </div>
    </div>
  );
};

export default TicketNoBuy;
